import { TabsRoot, TabsList, TabsTrigger, TabsContent } from './Tabs';

// Compound object export for ergonomic API: Tabs.Root, Tabs.List, etc.
export const Tabs = {
  Root: TabsRoot,
  List: TabsList,
  Trigger: TabsTrigger,
  Content: TabsContent,
};

